
const returnsForm = document.getElementById("initiateReturn");

returnsForm.addEventListener('submit', (e) => {
    e.preventDefault();
    
    initiateReturn();
});


function initiateReturn() {
    const orderNo = document.querySelector('#inputOrderNo').value;
    const zipCode = document.querySelector('#inputZipCode').value;
    const alertEl = document.querySelector('.alert-msg');
    
    // Alert Node
    const alertNode = document.createElement('div');
    const alertTextNode = document.createElement('p');
    alertNode.classList.add('errors');
    
    // Empty Alert message 
    alertEl.innerHTML = "";
    
    // Generate Alert Message
    let alertMsg = "";
    let shouldRedirect = false;
    if ( orderNo == "" ) {
        alertMsg = "Please Enter Order Number.";
        // return false
        
    } else if ( zipCode == "" ) {
        alertMsg = "Please Enter Email.";
        // return false
        
    } else {
        alertMsg = "";
        shouldRedirect = true;
    }
    alertTextNode.innerHTML = alertMsg;
    alertNode.append( alertTextNode );
    if ( alertEl && alertMsg != "" ) alertEl.append( alertNode );
    
    
    // Submit Form + Redirect
    if ( orderNo != "" && zipCode != "" && shouldRedirect ) {
        // Check for GiddyUp orders (no longer supported)
        if ( orderNo.toUpperCase().includes('GP') ) {
            const gpAlertNode = document.createElement('div');
            const gpAlertTextNode = document.createElement('p');
            gpAlertNode.classList.add('errors');
            gpAlertTextNode.innerHTML = "We're unable to process your return online. Please contact customer service at <a href='mailto:support@zquiet.com'>support@zquiet.com</a> for assistance.";
            gpAlertNode.append( gpAlertTextNode );
            alertEl.append( gpAlertNode );
        }
        // RZ REDIRECT for Shopify orders
        else {
            window.location.href = `https://zquiet.com/a/returnzap?rzEmail=${ zipCode }&rzOrderNumber=${ orderNo }`;
        }
    }
    
    // wwww.example-store.com/path/to/returnzap?rzEmail=test@example.com&rzOrderNumber=12345678
};